/**
 * IndexedDB mínimo (clave → valor). El swap de versión usa `commit()` para escribir el
 * manifiesto activo y borrar el pendiente en UNA transacción: o pasa todo o no pasa nada.
 */
const DB_NAME = 'totem';
const STORE = 'kv';

let dbp: Promise<IDBDatabase> | null = null;

function open(): Promise<IDBDatabase> {
  if (dbp) return dbp;
  dbp = new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => {
      const db = req.result;
      db.onversionchange = () => db.close();
      resolve(db);
    };
    req.onerror = () => reject(req.error);
    req.onblocked = () => reject(new Error('IndexedDB bloqueada'));
  });
  dbp.catch(() => (dbp = null));
  return dbp;
}

function done(tx: IDBTransaction): Promise<void> {
  return new Promise((resolve, reject) => {
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error || new Error('Transacción abortada'));
  });
}

export async function kvGet<T>(key: string): Promise<T | undefined> {
  const db = await open();
  return new Promise((resolve, reject) => {
    const req = db.transaction(STORE, 'readonly').objectStore(STORE).get(key);
    req.onsuccess = () => resolve(req.result as T | undefined);
    req.onerror = () => reject(req.error);
  });
}

export async function kvSet(key: string, value: unknown): Promise<void> {
  const db = await open();
  const tx = db.transaction(STORE, 'readwrite');
  tx.objectStore(STORE).put(value, key);
  return done(tx);
}

/** Escribe y borra varias claves de forma atómica */
export async function kvCommit(puts: Record<string, unknown>, deletes: string[] = []): Promise<void> {
  const db = await open();
  const tx = db.transaction(STORE, 'readwrite');
  const os = tx.objectStore(STORE);
  for (const [k, v] of Object.entries(puts)) os.put(v, k);
  for (const k of deletes) os.delete(k);
  return done(tx);
}

/** Solo para pruebas */
export function __resetDbForTests() {
  dbp = null;
}
